import { IAnyStateTreeNode } from 'mobx-state-tree';
import { BaseInsightsQueryParams } from '../../constants';
import { getInsightsDateRange } from '../../../Insights/utils/insightsDateRangeUtils';

const insightsDateRangeValidator = (field: BaseInsightsQueryParams.START_DATE | BaseInsightsQueryParams.END_DATE) => (_: IAnyStateTreeNode, queryParams: URLSearchParams) => {
  const { startDate, endDate } = getInsightsDateRange(queryParams);
  return { [field]: field === BaseInsightsQueryParams.START_DATE ? startDate : endDate };
};

export default insightsDateRangeValidator;
